import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccessControl from '../../AccessControl';
import { MODULES_KEY, PERMISSION_OBJECT, ROUTES } from '../../common/constants';
import QuarterView from './QuarterView';
import './quarterView.less';

const ResourceViewWrapper = () => (
  <Switch>
    <Route
      exact
      path={ROUTES?.QUARTER_VIEW}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.QUARTER_VIEW}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <QuarterView {...props} />
        </AccessControl>
      )}
    />
  </Switch>
);
export default ResourceViewWrapper;
